export default {
    SELECT: (state, payload) => {
        state[payload.key] = payload.value;
    },
    RESET_RESEARCH: (state) => {
        
        state.fnsoum = '',
        state.frefc = '',
        state.fcol = '',
        state.fstatus = 'O',
        state.fdate_soum = '',
        state.fcetat = '',
        state.fcetatd = '',
        state.fcetate = '',
        state.fcetata = '',
        state.fcetatr = '',
        state.fcetatt = '',
        state.fcetat_sup = ''
    },
    DELETE_CRITERIA: (state, payload) => {
        state[payload.key] = '';
    },
    DELETE_ALL_CRITERIA: state => {
        state.fcetat = '';
        state.fcetatd = '';
        state.fcetate = '';
        state.fcetata = '';
        state.fcetatr = '';
        state.fcetatt = '';
        state.fcetat_sup = '';
        state.fstatus = '';
    }
};